import {sandbox, locations} from '@servicenow/ui-internal';
import getHostVariables from '../getHostVariables';
import {DISPATCH} from '../../symbols';
import log from '../../log';

const {INTERCEPTOR} = locations;

function sandboxInterceptor(effectInterceptor) {
	const {fn, type, position} = effectInterceptor;
	return {
		...effectInterceptor,
		fn: function sandboxedInterceptor(context) {
			const {
				coeffects: {host}
			} = context;
			if (type === 'effect')
				// don't need to wrap seismic defined interceptors
				return fn(context);

			const hostVariables = getHostVariables(host);
			return sandbox(fn, {
				args: [context],
				location: INTERCEPTOR,
				host,
				details: {
					type,
					position
				},
				dispatch: hostVariables[DISPATCH],
				log
			});
		}
	};
}

function forEachInterceptor(interceptors, target, map) {
	map.set(target, interceptors.map(sandboxInterceptor));
}

export function createInterceptors(actionHandlers) {
	const actionHandlerInterceptors = {};

	for (const k in actionHandlers) {
		actionHandlerInterceptors[k] = new Map();
		const {length: handlerCount} = actionHandlers[k];
		for (let i = 0; i < handlerCount; i++) {
			const {
				interceptors: {before, after},
				args,
				effect,
				handlers = [],
				target = 'host',
				behaviorOptions,
				capture,
				eventHandler,
				modifier,
				descendantOnly
			} = actionHandlers[k][i];
			let combinedInterceptors = actionHandlerInterceptors[k].has(target)
				? actionHandlerInterceptors[k].get(target)
				: [];

			const effectInterceptor = effect
				? {
						fn: function createEffectHandlerInterceptor(context) {
							return {
								...context,
								effects: [
									...context.effects,
									{
										effect,
										args: [...args, context.coeffects],
										modifier,
										options: behaviorOptions,
										descendantOnly
									}
								]
							};
						},
						type: 'effect',
						capture,
						eventHandler
				  }
				: null;

			const handlerInterceptors = handlers.map(handler => ({
				fn: function createHandlersInterceptor(context) {
					const {effect, args = []} = handler;
					return {
						...context,
						effects: [
							...context.effects,
							{
								effect,
								args: [...args, context.coeffects],
								modifier,
								options: behaviorOptions,
								descendantOnly
							}
						]
					};
				},
				type: 'effect',
				capture,
				eventHandler
			}));

			combinedInterceptors = [
				...combinedInterceptors,
				...before,
				...(effectInterceptor ? [effectInterceptor] : []),
				...handlerInterceptors,
				...after
			];
			actionHandlerInterceptors[k].set(target, combinedInterceptors);
		}

		actionHandlerInterceptors[k].forEach(forEachInterceptor);
	}

	return actionHandlerInterceptors;
}
